import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  buildHotelCxlDropRiskDashboardCopy,
  buildHotelCxlDropRiskOrdersPath,
} from "../../utils/orders/resolveHotelCxlDropRisk";
import {
  dismissHotelCxlDropRiskForToday,
  isHotelCxlDropRiskDismissedToday,
} from "./hotelCxlDropRiskDismiss";
import "./HotelCxlDropRiskBanner.css";

export default function HotelCxlDropRiskBanner({
  variant = "dashboard",
  summary,
  viewerIsOps = false,
  loading = false,
  filterActive = false,
}) {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() =>
    variant === "dashboard" ? isHotelCxlDropRiskDismissedToday() : false
  );

  const copy = useMemo(
    () => buildHotelCxlDropRiskDashboardCopy(summary, { viewerIsOps }),
    [summary, viewerIsOps]
  );

  const count = Number(summary?.count) || 0;
  if (loading && count === 0) return null;
  if (count <= 0 || !copy.title) return null;
  if (variant === "dashboard" && dismissed) return null;

  const severity =
    summary?.todayCount > 0 || summary?.minDaysLeft === 0
      ? "critical"
      : summary?.urgentCount > 0 || (summary?.minDaysLeft != null && summary.minDaysLeft <= 3)
        ? "urgent"
        : "warning";

  const goHotels = () => {
    navigate(buildHotelCxlDropRiskOrdersPath());
  };

  const hideToday = (e) => {
    e.stopPropagation();
    dismissHotelCxlDropRiskForToday();
    setDismissed(true);
  };

  return (
    <div
      className={`hotel-cxl-drop-risk-banner hotel-cxl-drop-risk-banner--${variant} hotel-cxl-drop-risk-banner--${severity}`}
      role="status"
    >
      <button
        type="button"
        className="hotel-cxl-drop-risk-banner__main"
        onClick={goHotels}
      >
        <span className="hotel-cxl-drop-risk-banner__count">{count}</span>
        <span className="hotel-cxl-drop-risk-banner__copy">
          <strong className="hotel-cxl-drop-risk-banner__title">{copy.title}</strong>
          <span className="hotel-cxl-drop-risk-banner__body">{copy.body}</span>
        </span>
        <span className="hotel-cxl-drop-risk-banner__cta">
          {filterActive ? "מציג הזמנות בסיכון" : "פתח הזמנות בסיכון"}
        </span>
      </button>
      {variant === "dashboard" ? (
        <button
          type="button"
          className="hotel-cxl-drop-risk-banner__dismiss"
          onClick={hideToday}
        >
          הסתר להיום
        </button>
      ) : null}
    </div>
  );
}
